import { API_METHODS_ENUM } from "../../httpService";
import values from "lodash/values";
import entries from "lodash/entries";
var LoaderState = /** @class */ (function () {
    function LoaderState(loaderState, options) {
        if (options === void 0) { options = {}; }
        this.loaderState = loaderState;
        this.options = options;
    }
    LoaderState.prototype.getRecent = function (prop) {
        var _a = this.options, _b = _a.keys, keys = _b === void 0 ? values(API_METHODS_ENUM) : _b, _c = _a.omitKeys, omitKeys = _c === void 0 ? [] : _c;
        return Math.max.apply(Math, entries(this.loaderState).map(function (_a) {
            var key = _a[0], obj = _a[1];
            if (!keys.includes(key)
                || omitKeys.includes(key))
                return 0;
            return obj[prop] || 0;
        }));
    };
    LoaderState.prototype.getRecentLoadingStartedAt = function () {
        return this.getRecent("loading_started_at");
    };
    LoaderState.prototype.getRecentLoadingFinishedAt = function () {
        return this.getRecent("loading_finished_at");
    };
    LoaderState.prototype.getRecentLoadingFailedAt = function () {
        return this.getRecent("loading_failed_at");
    };
    LoaderState.prototype.getLoaderStatus = function () {
        return {
            loading_started_at: this.getRecentLoadingStartedAt(),
            loading_finished_at: this.getRecentLoadingFinishedAt(),
            loading_failed_at: this.getRecentLoadingFailedAt()
        };
    };
    LoaderState.prototype.isLoading = function () {
        var _a = this.getLoaderStatus(), loading_started_at = _a.loading_started_at, loading_finished_at = _a.loading_finished_at, loading_failed_at = _a.loading_failed_at;
        return loading_started_at > loading_finished_at && loading_started_at > loading_failed_at;
    };
    LoaderState.prototype.hasLoaded = function () {
        var _a = this.getLoaderStatus(), loading_started_at = _a.loading_started_at, loading_finished_at = _a.loading_finished_at, loading_failed_at = _a.loading_failed_at;
        return loading_finished_at > loading_started_at && loading_finished_at > loading_failed_at;
    };
    LoaderState.prototype.hasErrored = function () {
        var _a = this.getLoaderStatus(), loading_started_at = _a.loading_started_at, loading_finished_at = _a.loading_finished_at, loading_failed_at = _a.loading_failed_at;
        return loading_failed_at > loading_started_at && loading_failed_at > loading_finished_at;
    };
    LoaderState.prototype.hasInitialized = function () {
        return this.getRecentLoadingStartedAt() > 0;
    };
    Object.defineProperty(LoaderState.prototype, "loading", {
        get: function () {
            return this.isLoading();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LoaderState.prototype, "loaded", {
        get: function () {
            return this.hasLoaded();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LoaderState.prototype, "errored", {
        get: function () {
            return this.hasErrored();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LoaderState.prototype, "status", {
        get: function () {
            return {
                errored: this.errored,
                loading: this.loading,
                loaded: this.loaded,
            };
        },
        enumerable: false,
        configurable: true
    });
    return LoaderState;
}());
export { LoaderState };
